import MainNamespace from 'vondutch/globalComponents/MainNamespace';

(new MainNamespace()).init();

